<template>
	<v-dialog v-model="isVisible" max-width="600" persistent>
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Pregunta
			</p-header-dialog>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
				<input
					class="question-section--row-input tw-w-full"
					placeholder="Pregunta"
					v-model="question.description"
				/>
			</section>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					:disabled="fieldsNone"
					type="primary"
					@click="saveNewQuestion"
					> Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';

export default {
	name: 'add-question-dialog',
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider },
	created() {
	},
	data() {
		return {
			isVisible: false,
			question: {
				description: null,
			},
		};
	},
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		saveNewQuestion() {
			if (!this.flagEditItem) {
				this.$emit('handleAddNewQuestion', this.question);
			}
			this.close();
		},
	},
	computed: {
		fieldsNone() {
			return !this.question.description;
		},
	},
	props: {
		selectedQuestion: {
			type: Object,
			default: () => {},
		},
		flagEditItem: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		selectedQuestion: {
			handler(newVal) {
				this.question = newVal;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.question-section--row {
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, placeholder);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/add-question-dialog.vue